var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessionalGoals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "contenitore",
    width: 70,
    height: 70,
    transform: "translate(285 633)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "obiettivi_professionali",
    "data-name": "obiettivi professionali",
    transform: "translate(-104 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_29",
    "data-name": "Gruppo di maschere 29",
    transform: "translate(-181 -334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fondo",
    d: "M3.371,63.393s-5.693-9.719-2.283-18.97S11,37.365,20.12,27.966C31.186,16.55,38.958,15.922,48.828,20.908c5.586,2.821,6.49,14.425,15.379,21.63,8.015,6.5,1.477,17.566-2.73,19.291a20.655,20.655,0,0,1-7.063,1.725S48.09,86.92,29.242,86.119,3.371,63.393,3.371,63.393Z",
    transform: "translate(286.1 616.06)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3217",
    "data-name": "Raggruppa 3217",
    transform: "translate(23874.701 -17887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1187",
    "data-name": "Tracciato 1187",
    d: "M383.8,603.225h-6.475a.826.826,0,0,1-.825-.825V588.941a.826.826,0,0,1,.825-.825H383.8a.826.826,0,0,1,.825.825V602.4a.826.826,0,0,1-.825.825Z",
    transform: "translate(-23956.023 17984.191)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1190",
    "data-name": "Tracciato 1190",
    d: "M747.93,281.576h-6.475a.826.826,0,0,1-.825-.825V220.441a.826.826,0,0,1,.825-.825h6.475a.826.826,0,0,1,.825.825v60.309A.826.826,0,0,1,747.93,281.576Z",
    transform: "translate(-24273.92 18305.906)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1191",
    "data-name": "Tracciato 1191",
    d: "M452.779,375.9a1.277,1.277,0,0,0-1.331-1.436l-2.257-4.14-.508,1.778,1.546,3.794a1.284,1.284,0,0,0,2.549,0Z",
    transform: "translate(-24019.039 18174.332)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1192",
    "data-name": "Tracciato 1192",
    d: "M68.816,317.769l1.257.918,4.138-4.412-1.855-1.355Z",
    transform: "translate(-23652.469 18248.813)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1193",
    "data-name": "Tracciato 1193",
    d: "M0,0H4.892V1.89h-3A1.89,1.89,0,0,1,0,0H0Z",
    transform: "matrix(-0.808, -0.59, 0.59, -0.808, -23580.822, 18570.438)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1194",
    "data-name": "Tracciato 1194",
    d: "M121.2,348.092h1.557l.74-6h-2.3Z",
    transform: "translate(-23698.201 18223.348)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1195",
    "data-name": "Tracciato 1195",
    d: "M0,0H4.892V1.89h-3A1.89,1.89,0,0,1,0,0H0Z",
    transform: "translate(-23572.441 18572.885) rotate(179.997)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1196",
    "data-name": "Tracciato 1196",
    d: "M394.77,385.253s.762,7.364-1.143,12.443l-1.4,9.649h-2.412l.254-11.427-.889-10.157S390.961,381.19,394.77,385.253Z",
    transform: "translate(-23967.096 18162.768)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1197",
    "data-name": "Tracciato 1197",
    d: "M76.433,202.829l2.539,8.761-4.952,7.872,2.476,2.095,5.65-8.824L80.5,201.94Z",
    transform: "translate(-23657.01 18345.699)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_101",
    "data-name": "Ellisse 101",
    cx: 3.118,
    cy: 3.118,
    r: 3.118,
    transform: "translate(-23577.221 18522.648)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1198",
    "data-name": "Tracciato 1198",
    d: "M364.077,253.345s1.9-1.27,4.063,1.524l.571,17.585s-1.651-2.285-5.079-.127-4.19-.254-4.19-.254S357.031,253.917,364.077,253.345Z",
    transform: "translate(-23940.781 18276.709)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1199",
    "data-name": "Tracciato 1199",
    d: "M413.365,266.953h0a2.223,2.223,0,0,1,2.1,2.1l.4,7.655,2.666,7.237-1.524,1.27-4.952-8.634-1.014-7.1a2.223,2.223,0,0,1,2.32-2.534Z",
    transform: "translate(-23986.16 18264.582)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1200",
    "data-name": "Tracciato 1200",
    d: "M392.164,197.989a.883.883,0,0,0,1.523-.49.9.9,0,0,0,0-.173,4.011,4.011,0,0,1-.179-.974.511.511,0,0,1,.093-.239c.406-.544,1.36.243,1.743-.249.235-.3-.041-.777.139-1.115.238-.445.943-.226,1.386-.47.492-.271.463-1.026.139-1.486a2.337,2.337,0,0,0-1.772-.9,4.752,4.752,0,0,0-2,.391,4,4,0,0,0-1.892,1.312,3.2,3.2,0,0,0-.324,2.726A5.139,5.139,0,0,0,392.164,197.989Z",
    transform: "translate(-23968.559 18330.115)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1201",
    "data-name": "Tracciato 1201",
    d: "M335.667,705.612H275.273c-.061,0-.111-.068-.111-.151s.05-.151.111-.151h60.393c.061,0,.111.068.111.151S335.728,705.612,335.667,705.612Z",
    transform: "translate(-23859.936 17882.445)",
    fill: "#b8b8b8",
    stroke: "#b8b8b8",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1202",
    "data-name": "Tracciato 1202",
    d: "M383.8,616.046h-6.475c-.456,0-.825-.683-.825-1.526V589.642c0-.842.37-1.525.825-1.526H383.8c.456,0,.825.683.825,1.526v24.879c0,.842-.37,1.525-.825,1.526Z",
    transform: "translate(-23941.023 17971.371)",
    fill: "#b8b8b8",
    stroke: "#b8b8b8",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1203",
    "data-name": "Tracciato 1203",
    d: "M383.8,632.682h-6.475c-.456,0-.825-1.091-.825-2.434v-39.7c0-1.344.37-2.433.825-2.434H383.8c.456,0,.825,1.091.825,2.434v39.7c0,1.344-.37,2.433-.825,2.434Z",
    transform: "translate(-23925.023 17954.736)",
    fill: "#b8b8b8",
    stroke: "#b8b8b8",
    strokeWidth: 0.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalGoals);
export default __webpack_public_path__ + "static/media/professional_goals.c14ae533837d4c477ec2f22fa60a6b13.svg";
export { ForwardRef as ReactComponent };